import { takeLatest, call, put } from 'redux-saga/effects'

import { CONTESTS_FETCH_REQUEST } from '../actions/constants'
import { addContests } from '../actions/contests'
import { showMessage } from '../actions/message'
import { IContest } from '../reducers/contests'
import { api } from '../utils/api'

interface IApiContest extends Omit<IContest, 'domande'> {
  domande: string
}

const parseQuestions = (
  questions: IApiContest['domande']
): IContest['domande'] => {
  return JSON.parse(questions.slice(7, questions.length - 2))
}

const transformContests = (contests: IApiContest[]): IContest[] => {
  return contests.map((contest: IApiContest) => ({
    ...contest,
    id_concorso: contest.id_concorso,
    titolo: contest.titolo,
    domande: parseQuestions(contest.domande),
  }))
}

function* fetchContests() {
  try {
    const data: IApiContest[] = yield call([api, api.get], '/contests')

    yield put(addContests(transformContests(data)))
  } catch {
    yield put(
      showMessage({
        message: 'Si è verificato un errore durante la ricerca dei concorsi',
        type: 'danger',
      })
    )
  }
}

export function* contestsSaga() {
  yield takeLatest(CONTESTS_FETCH_REQUEST, fetchContests)
}
